__turbopack_context__.v({
  "identity": "customer-answer-module__f-K-Aa__identity",
  "panel": "customer-answer-module__f-K-Aa__panel",
  "record": "customer-answer-module__f-K-Aa__record",
  "tabs": "customer-answer-module__f-K-Aa__tabs",
});
